import { handleError } from "../../../helperFunctions";
import { BaseAPIResponse } from "../../../utils/types";
import { baseApi } from "../../api";
import {
  BulkUploadMembersResponse,
  CooperativeMembersQuery,
  CooperativeMembersResponse,
  SingleCooperativeMemberResponse,
} from "./membership.type";

export const membershipApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    initiateMemberRemoval: builder.mutation<
      BaseAPIResponse,
      {
        coop: number;
        id: number;
      }
    >({
      query: (payload) => {
        return {
          url: `/Membership/Removal`,
          method: "POST",
          body: payload,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),

    downloadBulkMemberTemplate: builder.mutation<
      void,
      { fileName: string; coop: number; file: "csv" }
    >({
      query: ({ fileName, ...params }) => {
        return {
          url: "/Membership/Detail/upload",
          method: "GET",
          params: params,
          responseHandler: async (response) => {
            const blob = await response.blob();

            const filename = fileName;

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

            return undefined;
          },
          responseType: "blob",
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),

    adminBulkUploadMembers: builder.mutation<
      BulkUploadMembersResponse,
      FormData
    >({
      query: (payload) => {
        return {
          url: `/Membership/Detail/upload`,
          method: "POST",
          body: payload,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),

    getCooperativeMembers: builder.query<
      CooperativeMembersResponse,
      CooperativeMembersQuery
    >({
      query: (params) => {
        return {
          url: `/Cooperative/members`,
          method: "GET",
          params: params,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, false);
        }
      },
    }),

    getSingleCooperativeMember: builder.query<
      SingleCooperativeMemberResponse,
      { form: boolean; coop: number; id: number }
    >({
      query: (params) => {
        return {
          url: `/Membership/Detail/Admin`,
          method: "GET",
          params: params,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, false);
        }
      },
    }),

    inviteMember: builder.mutation<
      BaseAPIResponse,
      {
        email: string[];
        coop: number;
        isPaymentRequired: boolean;
      }
    >({
      query: (payload) => {
        return {
          url: `/Membership/Invitation/link/send`,
          method: "POST",
          body: payload,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),
  }),
});

export const {
  useInitiateMemberRemovalMutation,
  useAdminBulkUploadMembersMutation,
  useDownloadBulkMemberTemplateMutation,
  useGetCooperativeMembersQuery,
  useLazyGetCooperativeMembersQuery,
  useGetSingleCooperativeMemberQuery,
  useInviteMemberMutation,
} = membershipApi;
